export default __webpack_public_path__ + "static/media/plus.d2c8885b.svg";